/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL Encoder / Decoder — Percent-encoding | Toolverse`)
};

const es_ue_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador/Decodificador de URL — Codificación de porcentaje | Toolverse`)
};

const de_ue_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-Kodierer / Dekoder — Prozentcodierung | Toolverse`)
};

const nl_ue_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-encoder / -decoder — Percent-codering | Toolverse`)
};

const fr_ue_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encodeur / Décodeur URL — Encodage en pourcentage | Toolverse`)
};

const it_ue_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificatore URL / Decodificatore — Percent-encoding | Toolverse`)
};

const pt_br2_ue_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador / Decodificador de URL — Codificação por porcentagem | Toolverse`)
};

const pt_ue_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador / Descodificador de URL — Codificação em percentual | Toolverse`)
};

const ja_ue_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URLエンコーダー / デコーダー — パーセント エンコーディング | Toolverse`)
};

const zh_ue_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL 编码器 / 解码器 — 百分号编码 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_meta_title", locale)
	if (locale === "en") return en_ue_meta_title(inputs)
	if (locale === "es") return es_ue_meta_title(inputs)
	if (locale === "de") return de_ue_meta_title(inputs)
	if (locale === "nl") return nl_ue_meta_title(inputs)
	if (locale === "fr") return fr_ue_meta_title(inputs)
	if (locale === "it") return it_ue_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_ue_meta_title(inputs)
	if (locale === "pt") return pt_ue_meta_title(inputs)
	if (locale === "ja") return ja_ue_meta_title(inputs)
	return zh_ue_meta_title(inputs)
};